<script setup lang="ts">
import type { PlaceholderProps } from "./placeholder.types";
import { usePlaceholder } from "./usePlaceholder";

const props = defineProps<PlaceholderProps>();

const { classes, hasContent } = usePlaceholder({ props });
</script>

<template>
  <div part="base" :class="classes" class="e-placeholder" role="presentation" aria-hidden="true">
    <span v-show="hasContent" class="e-placeholder__slot">
      <slot />
    </span>
  </div>
</template>

<style>
:host {
  display: contents;
}

.e-placeholder__root {
  min-height: 8rem;
  width: 100%;
  border-radius: 0.5rem;
  border: 1px solid color-mix(in srgb, var(--color-foreground) 12%, transparent);
  background-image: repeating-linear-gradient(
    -45deg,
    color-mix(in srgb, var(--color-foreground) 4%, transparent) 0px,
    color-mix(in srgb, var(--color-foreground) 4%, transparent) 1px,
    transparent 1px,
    transparent 8px
  );
  display: flex;
  align-items: center;
  justify-content: center;
}

.e-placeholder__slot {
  display: inline-flex;
  backdrop-filter: blur(20px);
  background: color-mix(in srgb, var(--color-background) 60%, transparent);
  padding: 0.25rem 0.75rem;
  border-radius: 0.375rem;
}
</style>
